import { Dialog, DialogActions, DialogContent, MenuItem } from "@mui/material";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import signatarios from "../AnexoContrato/signatarios.json";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import WhiteButton from "../../components/WhiteButton";
import BlueButton from "../../components/BlueButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import GenericDatePicker from "../../components/GenericDatePicker";
import {
  buscaTodosNotSign,
  buscaTodosSignatario,
} from "../../services/api-contratos.service";
import SnackBar from "../../components/SnackBar";
import {
  buscarComboPorCodigo,
  buscarFuncionalidades,
  buscarUsuarios,
  cadastrarUsuario,
  inserirFuncionalidadesExtraordiarias,
} from "../../services/auth.service";
import { generateRandomPassword } from "../../utils/generatePassword.util";
import BasicSelect from "../../components/BasicSelect";

const Step2 = ({
  handleAvancar,
  handleVoltar,
  right,
  setRight,
  disableButtons,
}) => {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [pesquisaSignatarios, setPesquisaSignatarios] = useState("");
  const [pesquisaNewSignatarios, setPesquisaNewSignatarios] = useState("");
  const [openSignatarios, setOpenSignatarios] = useState(false);
  const [pesquisaAddSignatario, setpesquisaAddSignatario] = useState(false);
  const [openCrud, setOpenCrud] = useState(false);
  const [salvaSignatario, setSalvaSignatario] = useState(false);
  const [novoSignatario, setNovoSignatario] = useState({
    nome: "",
    login: "",
    email: "",
    grupo: "",
    dtExpiracao: "",
  });
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [dataSignatario, setDataSignatarios] = useState([]);
  const [users, setUsers] = useState({
    notSign: [],
    sign: [],
    originalUsers: [],
  });

  console.log(right);

  useEffect(() => {
    const buscarGrupoSignatario = async () => {
      const response = await buscarComboPorCodigo("GRUPOUSUARIO");
      const findSignatario = response.detalhes.itensCombo.find((grupo) =>
        grupo.includes("SIGNATARIO")
      );
      setNovoSignatario({
        ...novoSignatario,
        idGrupoUsuario: findSignatario.split("/|/")[0],
      });
    };

    buscarGrupoSignatario();
  }, []);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  function not(a, b) {
    return a.filter((value) => !b.includes(value));
  }

  function intersection(a, b) {
    return a.filter((value) => b.includes(value));
  }

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const getDataSignatarios = async () => {
    setLoading(true);
    try {
      let listaSemDuplicatas = [];
      const response = await buscaTodosSignatario();
      if (right.length > 0) {
        //endpoint de buscatodos precisa retornar tipoSignatario
        const lista = response?.signatarios.filter(
          (item) => !right.some((item2) => item.id === item2.id)
        );
        listaSemDuplicatas = lista;
      } else {
        listaSemDuplicatas = response?.signatarios;
      }

      if (users.sign.length > 0) {
        console.log("entrou");

        const idUsuarioNewSigners = users.sign.map((item) => item.idUsuario);
        const signatariosRight = listaSemDuplicatas.filter((sign) =>
          idUsuarioNewSigners.includes(sign.id)
        );
        const signatariosLeft = listaSemDuplicatas.filter(
          (sign) => !idUsuarioNewSigners.includes(sign.id)
        );

        setRight([...right, ...signatariosRight]);
        setLeft(signatariosLeft);
      } else {
        setLeft(listaSemDuplicatas);
      }

      setDataSignatarios(listaSemDuplicatas);
    } catch (error) {
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataSignatarios();
  }, []);

  const getDataUsersNotSign = async () => {
    setLoading(true);
    try {
      const response = await buscaTodosNotSign();

      const usersFilter = response.usersNotSign.map((user) => ({
        nomeCompleto: user.nome_completo === null ? "" : user.nome_completo,
        idUsuario: user.id_usuario,
        idsFuncionalidade: user.ids_funcionalidades,
      }));

      setUsers({
        ...users,
        notSign: usersFilter,
        originalUsers: usersFilter,
      });
    } catch (error) {
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pesquisaAddSignatario) {
      getDataUsersNotSign();
    }
  }, [pesquisaAddSignatario]);

  const handleSubmitAddFuncionalidade = async () => {
    try {
      if (users.sign.length > 0) {
        const responseFuncionalidade = await buscarFuncionalidades();

        const idFuncionalidadeSignatario =
          responseFuncionalidade.funcionalidades.find(
            (funcionalidade) =>
              funcionalidade.chave === "PODE_ASSINAR_DOCUMENTOS"
          );

        for (let index = 0; index < users.sign.length; index++) {
          const element = users.sign[index];

          console.log(!element.idsFuncionalidade[0]);

          const funcionalidades = !element.idsFuncionalidade[0]
            ? [idFuncionalidadeSignatario.idFuncionalidade]
            : [
                ...element.idsFuncionalidade,
                idFuncionalidadeSignatario.idFuncionalidade,
              ];

          const response = await inserirFuncionalidadesExtraordiarias(
            element.idUsuario,
            {
              funcionalidades,
            }
          );
        }
        await getDataSignatarios();
        modalSetFuncionalidade();

        setObjSnackBar({
          type: "success",
          msg: "Signatários adicionados com sucesso",
        });
      } else {
        setObjSnackBar({ type: "error", msg: "Nenhum usuário selecionado!" });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const modalSetFuncionalidade = () => {
    if (pesquisaAddSignatario) {
      setUsers({
        notSign: [],
        sign: [],
        originalUsers: [],
      });
      setPesquisaNewSignatarios("");
    }
    setpesquisaAddSignatario(!pesquisaAddSignatario);
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    const objctRigth = left.map((item) => ({ ...item, type: "" }));
    setRight(right.concat(objctRigth));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const formatNameSignatario = (value) => {
    return value.replace(/[^a-zA-Z0-9]/g, " ");
  };

  const handleNovoSignatarioChange = (field, value) => {
    setNovoSignatario((prevState) => ({
      ...prevState,
      [field]: field === "nome" ? formatNameSignatario(value) : value,
    }));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const handleCheckNewSign = (newSign) => {
    const isUserInSign = users.sign.some(
      (user) => user.idUsuario === newSign.idUsuario
    );

    if (isUserInSign) {
      const updatedSign = users.sign.filter(
        (user) => user.idUsuario !== newSign.idUsuario
      );
      setUsers({ ...users, sign: updatedSign });
    } else {
      const updatedSign = [...users.sign, newSign];
      setUsers({ ...users, sign: updatedSign });
    }
  };

  const handleSearchNewSign = (e) => {
    const value = e.target.value;
    setPesquisaNewSignatarios(value);

    if (value) {
      const newArrayValue = users.notSign.filter((item) =>
        item.nomeCompleto.toLowerCase().includes(value.toLowerCase())
      );

      setUsers({
        ...users,
        notSign: [...new Set([...(users.sign || []), ...newArrayValue])],
      });
    } else {
      setUsers({
        ...users,
        notSign: [...new Set([...(users.sign || []), ...users.originalUsers])],
      });
    }
  };

  const handleSearchDataSign = (e) => {
    const value = e.target.value;
    setPesquisaSignatarios(value);

    if (value) {
      const newArrayValue = left.filter((item) =>
        item.nome.toLowerCase().includes(value.toLowerCase())
      );

      setLeft(newArrayValue);
    } else {
      setLeft(dataSignatario);
    }
  };

  const handleModalNovoSign = (estado) => {
    setOpenCrud(estado);
    if (!estado) {
      setNovoSignatario({
        nome: "",
        login: "",
        email: "",
        grupo: "",
        dtExpiracao: "",
      });
    }
  };

  useEffect(() => {
    const sttRight = () => {
      const listLeft = left?.filter(
        (item) => !right.some((item2) => item.id === item2.id)
      );

      setLeft(listLeft);
    };

    sttRight();
  }, [right]);

  const handleSalvaSignatario = async () => {
    try {
      const senha = generateRandomPassword(10);
      const response = await cadastrarUsuario("I", {
        ...novoSignatario,
        senha,
      });

      const newUser = {
        nome: novoSignatario.nome,
        id: response.idUsuario,
        email: novoSignatario.email,
        tipoSignatario: novoSignatario.tipoSignatario,
      };
      setUsers({ ...users, sign: [...users.sign, newUser] });
      setRight([...right, newUser]);

      // await handleSubmitAddFuncionalidade();
      // await getDataUsersNotSign();

      setNovoSignatario({
        nome: "",
        login: "",
        email: "",
        grupo: "",
        dtExpiracao: "",
      });
      modalSetFuncionalidade();

      setOpenCrud(false);
    } catch (error) {
      console.log(error);
      setObjSnackBar({ type: "error", msg: error.response.data.mensagem });
    }
  };

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const handleTypeSign = (e, index) => {
    const value = e.target.value;
    setRight(
      right.map((item, i) =>
        i === index ? { ...item, tipoSignatario: value } : item
      )
    );
  };

  const customList = (items) => (
    <>
      <div
        style={{
          fontWeight: "bold",
          color: "#18316e",
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        {items === left
          ? "Selecionar signatários:"
          : "Signatários selecionados:"}
      </div>

      <Paper
        sx={{
          minWidth: 300,
          maxWidth: 500,
          height: 230,
          overflow: "auto",
          padding: 2,
        }}
      >
        {items === left && (
          <TextField
            fullWidth
            label="Pesquisar Signatário"
            variant="outlined"
            size="small"
            value={pesquisaSignatarios}
            onChange={handleSearchDataSign}
            InputProps={{ startAdornment: <SearchIcon /> }}
          />
        )}
        <List dense component="div" role="list">
          {!loading
            ? items.map((value, index) => {
                const labelId = `transfer-list-item-${value.id}-label`;

                return (
                  <div className={styles.containerTopic__signatario}>
                    <ListItemButton
                      key={value.id}
                      role="listitem"
                      onClick={handleToggle(value)}
                    >
                      <ListItemIcon>
                        <Checkbox
                          checked={checked.includes(value)}
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={value.nome} />
                    </ListItemButton>
                    {items === right ? (
                      <BasicSelect
                        label="Tipo Signatáro:"
                        options={["Parte", "Testemunha"]}
                        onChange={(e) => handleTypeSign(e, index)}
                        value={right[index].tipoSignatario}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                );
              })
            : ""}
        </List>
        {items === left && (
          <Button
            fullWidth
            startIcon={<AddIcon />}
            onClick={modalSetFuncionalidade}
            style={{ marginTop: 8 }}
          >
            Adicionar Novo Signatário
          </Button>
        )}
      </Paper>
    </>
  );

  return (
    <>
      <DialogContent>
        <div className={styles.container_legenda}>
          <div className={`${styles.accordion} ${isOpen ? styles.open : ""}`}>
            <button
              className={styles.accordionHeader}
              onClick={toggleAccordion}
            >
              <h4 style={{ display: "flex", alignItems: "center" }}>
                {" "}
                <InfoIcon sx={{ marginRight: ".5rem" }} />
                Legenda
              </h4>{" "}
              <ExpandMoreIcon />
            </button>
            <div className={styles.accordionContent}>
              <div className={styles.info_legenda}>
                <InfoOutlinedIcon
                  sx={{ marginRight: ".2rem" }}
                  fontSize=".5rem"
                />{" "}
                Marque um signatário e clique em uma das ações como descrito
                abaixo:
              </div>
              <div className={styles.container_btn_legenda}>
                <div className={styles.btn_legenda_esq}>
                  <div>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      aria-label="move all right"
                    >
                      ≫
                    </Button>{" "}
                    Selecionar todos
                  </div>
                  <div>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      aria-label="move selected right"
                    >
                      &gt;
                    </Button>{" "}
                    Selecionar apenas os marcados
                  </div>
                </div>
                <div className={styles.btn_legenda_dir}>
                  <div>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      aria-label="move selected left"
                    >
                      &lt;
                    </Button>{" "}
                    Desselecionar apenas os marcados
                  </div>
                  <div>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      aria-label="move all left"
                    >
                      ≪
                    </Button>{" "}
                    Desselecionar todos
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Grid
          container
          spacing={5}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <Grid item sx={{ padding: "1rem" }}>
            {customList(left)}
          </Grid>
          <Grid item>
            <Grid container direction="column" sx={{ alignItems: "center" }}>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleAllRight}
                disabled={left.length === 0}
                aria-label="move all right"
              >
                ≫
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                &gt;
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                &lt;
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleAllLeft}
                disabled={right.length === 0}
                aria-label="move all left"
              >
                ≪
              </Button>
            </Grid>
          </Grid>
          <Grid item>{customList(right)}</Grid>
        </Grid>
        {!disableButtons && (
          <DialogActions className={styles.container_btn}>
            <Button
              className={styles.btn_close}
              onClick={handleVoltar}
              variant="outlined"
            >
              Voltar
            </Button>
            <Button
              className={right.length !== 0 ? styles.btn_avancar : ""}
              onClick={handleAvancar}
              variant="contained"
              disabled={right.length === 0}
            >
              Avançar
            </Button>
          </DialogActions>
        )}
      </DialogContent>

      <Dialog open={pesquisaAddSignatario} onClose={modalSetFuncionalidade}>
        <DialogContent>
          <div className={styles.container_add_signatario}>
            <h3 className={styles.pesquisa_signatario}>
              Verifique se o signatário que está <br />
              procurando consta na base
            </h3>
            <TextField
              fullWidth
              size="small"
              label="Pesquisar Usuários"
              value={pesquisaNewSignatarios}
              onChange={handleSearchNewSign}
              InputProps={{
                startAdornment: <SearchIcon style={{ marginRight: 8 }} />,
              }}
            />
          </div>
          <div className={styles.container__users}>
            {!loading
              ? users.notSign.map((item) => (
                  <label
                    key={item.id}
                    className={`${styles.topic__users} ${
                      users.sign.some(
                        (user) => user.idUsuario === item.idUsuario
                      )
                        ? styles.topic__users_checker
                        : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={users.sign.includes(item)}
                      onChange={() => handleCheckNewSign(item)}
                    />
                    <span>{item.nomeCompleto}</span>
                  </label>
                ))
              : ""}
            <Button
              fullWidth
              startIcon={<AddIcon />}
              onClick={() => setOpenCrud(true)}
            >
              Adicionar Novo Signatário
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <div className={styles.conteinerBtnSignatarios}>
            <WhiteButton
              clickFunction={modalSetFuncionalidade}
              contentIcon={<CloseIcon />}
              textValue="Cancelar"
              iconLeft
            />
            <BlueButton
              clickFunction={handleSubmitAddFuncionalidade}
              contentStartIcon={<CheckIcon />}
              textValue="Salvar"
            />
          </div>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openCrud}
        onClose={() => handleModalNovoSign(false)}
        maxWidth="md"
      >
        <DialogContent>
          <div className={styles.container_crud}>
            <h3>Cadastrar novo signatário</h3>
            <TextField
              size="small"
              label="Nome:"
              value={novoSignatario.nome}
              onChange={(e) =>
                handleNovoSignatarioChange("nome", e.target.value)
              }
            >
              {" "}
            </TextField>
            <TextField
              size="small"
              label="Login:"
              value={novoSignatario.login}
              onChange={(e) =>
                handleNovoSignatarioChange("login", e.target.value)
              }
            >
              {" "}
            </TextField>
            <TextField
              size="small"
              label="Email:"
              value={novoSignatario.email}
              onChange={(e) =>
                handleNovoSignatarioChange("email", e.target.value)
              }
            >
              {" "}
            </TextField>
            <TextField size="small" label="Grupo:" value="Signatário" disabled>
              {" "}
            </TextField>
            <GenericDatePicker
              label="Dt. Expiração"
              value={novoSignatario.dtExpiracao}
              onChange={(e) => {
                handleNovoSignatarioChange("dtExpiracao", e);
              }}
              required
            />
          </div>
          <DialogActions>
            <div className={styles.conteinerBtnCrud}>
              <WhiteButton
                clickFunction={() => handleModalNovoSign(false)}
                contentIcon={<CloseIcon />}
                textValue="Cancelar"
                iconLeft
              />
              <BlueButton
                clickFunction={() => handleSalvaSignatario()}
                contentStartIcon={<CheckIcon />}
                textValue="Salvar"
              />
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default Step2;
